import { PrivilegedRoute } from '@middlewares';

import UploadInformation from '@pages/Reconocimientos/UploadInformation';

const ReconocimientosRoutes = [
  {
    path: '/reconocimientos/upload',
    element: <PrivilegedRoute title="Subir información" page={<UploadInformation />} />,
  },
];

export default ReconocimientosRoutes;
